module.exports = __webpack_public_path__ + "img/mac-img.072440b1.png";